module.exports = __webpack_public_path__ + "img/615.c6dfbefa.jpg";